import { safeStringify } from '../services/apiClient';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const handle = async (res) => {
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { message: text };
  }
  if (!res.ok) throw new Error(data?.message || 'Request failed');
  return data;
};

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') qs.set(key, val);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

const authHeaders = (token, isJson = true) => ({
  Authorization: `Bearer ${token}`,
  ...(isJson ? { 'Content-Type': 'application/json' } : {}),
});

export const getSummary = async (token) => {
  const res = await fetch(`${API_BASE}/api/host/earnings/summary`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  return handle(res);
};

export const getLedger = async (token, params = {}) => {
  const res = await fetch(`${API_BASE}/api/host/earnings/ledger${buildQuery(params)}`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  return handle(res);
};

export const exportLedgerCsv = async (token, params = {}) => {
  const res = await fetch(`${API_BASE}/api/host/earnings/ledger${buildQuery({ ...params, export: 'csv' })}`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Failed to export CSV');
  return res.text();
};

export const getLedgerItem = async (token, id) => {
  const res = await fetch(`${API_BASE}/api/host/earnings/ledger/${id}`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  return handle(res);
};

export const listPayouts = async (token) => {
  const res = await fetch(`${API_BASE}/api/host/payouts`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  return handle(res);
};

export const getPayoutDetail = async (token, id) => {
  const res = await fetch(`${API_BASE}/api/host/payouts/${id}`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  return handle(res);
};

export const getPayoutAccount = async (token) => {
  const res = await fetch(`${API_BASE}/api/host/payout-account`, {
    headers: authHeaders(token, false),
    credentials: 'include',
  });
  return handle(res);
};

export const savePayoutAccount = async (token, payload) => {
  const res = await fetch(`${API_BASE}/api/host/payout-account`, {
    method: 'POST',
    headers: authHeaders(token),
    credentials: 'include',
    body: safeStringify(payload),
  });
  return handle(res);
};

export const requestPayout = async (token) => {
  const res = await fetch(`${API_BASE}/api/host/payouts/request`, {
    method: 'POST',
    headers: authHeaders(token),
    credentials: 'include',
  });
  return handle(res);
};


